import { createFeatureScope } from 'bundles/product-features';

// Kept in its own scope, separate from `productFeatureFlags`'s finaid/partner-access features: `createFeatureScope`
// requests every feature in a scope on every call, so sharing a scope with those near-universal features would
// smuggle this experiment-only feature into their course/specialization-scoped queries on every XDP.
export const { useProductFeatures } = createFeatureScope({
  commerceMonetization: {
    excludeLearnerSubscribedPriorToCurrentMonetizationExperiment: false,
  },
});
